module.exports = __webpack_public_path__ + "img/bot1.7ee32117.png";